<template>
  <card>
    <div class="card-body">
      <ValidationObserver ref="form">
        <form @submit.prevent="validate">
          <div class="row">
            <div class="col-3">
              <ValidationProvider
                name="courseName"
                rules="required|max:255"
                v-slot="{ passed, failed }"
              >
                <fg-input
                  name="courseName"
                  :error="failed ? 'The Course Name is required': null"
                  :has-success="passed"
                  required
                  label="Course Name"
                  placeholder="Course Name"
                  max-length="255"
                  v-model="course.CourseName"
                />
              </ValidationProvider>
            </div>
            <div class="col-3">
              <ValidationProvider
                name="hostingCouncil"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <fg-input>
                  <label>Host Council</label>
                  <el-select
                    class="select-default2"
                    size="large"
                    name="hostingCouncil"
                    :error="failed ? 'The Host Council is required': null"
                    :has-success="passed"
                    placeholder=""
                    v-model="course.CouncilId"
                  >
                    <el-option
                      v-for="c in councils"
                      class="select-default2"
                      :value="c.Id"
                      :label="c.CouncilName"
                      :key="c.Id"
                    />
                  </el-select>
                </fg-input>
              </ValidationProvider>
            </div>
            <div class="col-3">
              <fg-input
                name="curriculumYear"
                readonly
                title="Curriculum Year"
                label="Curriculum Year"
                type="number"
                placeholder="Curriculum Year"
                v-model="course.CurriculumYear"
              />
            </div>
            <div class="col-3">
              <fg-input
                name="deliveryStyle"
                readonly
                title="Delivery Style"
                label="Delivery Style"
                v-model="deliverStyleName"
              />
            </div>
          </div>
          <div
            class="row"
            align-h="between"
          >
            <div
              class="col-7"
              id="participating"
            >
              <div class="form-group">
                <label>Participating Councils</label>
                <textarea
                  rows="9"
                  style="height:100%;"
                  class="form-control border-input"
                  placeholder="Other Councils participating in this course"
                  v-model="course.ParticipatingCouncils"
                />
              </div>
            </div>
            <div class="col-5">
              <label />
              <div class="row">
                <div class="col-6">
                  <label>Participant Price</label>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <fg-input
                      name="particpantPrice"
                      type="number"
                      v-model="course.ParticipantPrice"
                      addon-left-styles="padding-top:0px;padding-bottom:0px;"
                    >
                      <template slot="addonLeft">
                        $
                      </template>
                    </fg-input>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label>Staff Price</label>
                </div>
                <div class="col-6">
                  <fg-input
                    name="staffPrice"
                    type="number"
                    v-model="course.StaffPrice"
                    addon-left-styles="padding-top:0px;padding-bottom:0px;"
                  >
                    <template slot="addonLeft">
                      $
                    </template>
                  </fg-input>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-info btn-fill btn-wd"
            >
              Update Course Info
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </card>
</template>

<script>
import courseApi from '@/services/api/course'

export default {
  name: 'CourseHeaderEdit',
  components: {
  },
  props: [],
  data: function () {
    return {
      errormessage: null,
      course: {
        CourseName: null,
        HostingCouncil: null,
        ParticipatingCouncils: null,
        CurriculumYear: null,
        DeliverStyle: null,
        StaffPrice: null,
        ParticipantPrice: null
      },
      councils: []
    }
  },
  computed: {
    deliverStyleName: function () {
      if (this.DeliverStyle === 'Weeklong') {
        return '5 x 1 Weeklong format'
      } else {
        return '3 x 2 Weekends'
      }
    }
  },
  mounted () {
    this.councils = this.getCouncils()
    courseApi.get(this.$root.courseKey)
      .then(x => {
        this.course = x
      })
      .catch(error => {
        console.log(error)
        this.$notify({
          message: 'There was an error retrieving your data.',
          icon: 'bi bi-exclamation-circle-fill',
          type: 'error',
          horizontalAlign: 'center',
          timeout: 2000
        })
        this.errormessage = error
      })
      .finally(() => {
        this.loading = false
      })
  },
  methods: {
    validate: function () {
      return this.$refs.form.validate().then(res => {
        if (res) {
          this.updateCourse()
        }
        return res
      })
    },
    getCouncils: function () {
      courseApi.getCouncilLookups()
        .then(x => {
          this.councils = x
        })
        .catch(error => {
          console.log(error)
          this.$notify({
            message: 'There was an error retrieving your data.',
            icon: 'bi bi-exclamation-circle-fill',
            type: 'error',
            horizontalAlign: 'center',
            timeout: 2000
          })
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateCourse: function () {
      courseApi.update(this.course)
        .then(x => {
          this.course = x
          this.$root.courseName = x.CourseName
          this.$notify({
            message: 'The course has been updated.',
            icon: 'nc-icon nc-satisfied',
            type: 'success',
            horizontalAlign: 'center',
            timeout: 2000
          })
        })
        .catch(error => {
          console.log(error)
          this.errormessage = error
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
